class NodeFunctionInput {
  constructor(type, name) {
    let count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let qualifier = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    let isConst = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    this.type = type;
    this.name = name;
    this.count = count;
    this.qualifier = qualifier;
    this.isConst = isConst;
  }

}

NodeFunctionInput.isNodeFunctionInput = true;
export default NodeFunctionInput;